import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לזה בשם: “בדידות רומנטית”",
    opening: localizedGenderNode(
      [
      "היום אני לא מתווכח עם זה. אני קורא לזה בשם — ומפסיק להאשים את עצמי."
    ],
      [
      "היום אני לא מתווכח עם זה. אני קורא לזה בשם — ומפסיק להאשים את עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “בדידות היא תחושה. היא לא הוכחה 강조 משהו בי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “בדידות היא תחושה. היא לא הוכחה 강조 משהו בי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מתי אני מרגיש/ה את הבדידות הרומנטית הכי חזק? (רגע/שעה/מקום)\n[כאן אני כותב]",
      "2. מה הדבר שהכי חסר לי בתוך זה? (מגע/שייכות/מישהו לבחור בי/חום/שיחה אינטימית)\n[כאן אני כותב]",
      "3. איך הבדידות מרגישה בגוף? (חזה/בטן/גרון/עייפות)\n[כאן אני כותב]"
    ],
      [
      "1. מתי אני מרגיש/ה את הבדידות הרומנטית הכי חזק? (רגע/שעה/מקום)\n[כאן אני כותב]",
      "2. מה הדבר שהכי חסר לי בתוך זה? (מגע/שייכות/מישהו לבחור בי/חום/שיחה אינטימית)\n[כאן אני כותב]",
      "3. איך הבדידות מרגישה בגוף? (חזה/בטן/גרון/עייפות)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום עשיתי צעד אמיתי: נתתי שם לחוויה, בלי להילחם בה."
    ],
      [
      "סגירה",
      "היום עשיתי צעד אמיתי: נתתי שם לחוויה, בלי להילחם בה."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה הבדידות — נשימה אחת + משפט: “זה רגש. אני נשאר/ת איתי.”",
      "כשעולה הבדידות — נשימה אחת + משפט: “זה רגש. אני נשאר/ת איתי.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "להפריד בין בדידות לבין “אני לא שווה”",
    opening: localizedGenderNode(
      [
      "היום אני מפריד בין תחושה לבין מסקנה."
    ],
      [
      "היום אני מפריד בין תחושה לבין מסקנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הרגש חזק — אבל הוא לא שופט.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הרגש חזק — אבל הוא לא שופט.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה משפט אוטומטי עולה לי כשאני מרגיש/ה לבד? (“אף אחד לא ירצה אותי”, “אני מאחור”)\n[כאן אני כותב]",
      "2. מה העובדה היבשה? (בלי פרשנות — שתי שורות)\n[כאן אני כותב]",
      "3. איזו אמת עדינה אחת אפשר להגיד היום במקום המשפט האוטומטי?\n[כאן אני כותב]"
    ],
      [
      "1. איזה משפט אוטומטי עולה לי כשאני מרגיש/ה לבד? (“אף אחד לא ירצה אותי”, “אני מאחור”)\n[כאן אני כותב]",
      "2. מה העובדה היבשה? (בלי פרשנות — שתי שורות)\n[כאן אני כותב]",
      "3. איזו אמת עדינה אחת אפשר להגיד היום במקום המשפט האוטומטי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת להפוך בדידות לכתב אישום."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת להפוך בדידות לכתב אישום."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “זה סיפור. אני חוזר/ת לעובדות.” + נשימה.",
      "פעם אחת היום: “זה סיפור. אני חוזר/ת לעובדות.” + נשימה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הדחף למלא את הריק מהר (ולעצור לפני פעולה)",
    opening: localizedGenderNode(
      [
      "היום אני בונה עצירה לפני פעולה שמגיעה מפחד."
    ],
      [
      "היום אני בונה עצירה לפני פעולה שמגיעה מפחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא רוצה/ת למלא ריק מיד.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא רוצה/ת למלא ריק מיד.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה הפעולה האימפולסיבית שלי כשאני לבד? (לגלול, לשלוח הודעה, דייט לא נכון, אוכל, אלכוהול)\n[כאן אני כותב]",
      "2. מה אני באמת מנסה להרגיע דרך זה? (פחד, שקט, אישור, חוסר ערך)\n[כאן אני כותב]",
      "3. מה חלופה אחת נקייה שמכבדת אותי היום?\n[כאן אני כותב]"
    ],
      [
      "1. מה הפעולה האימפולסיבית שלי כשאני לבד? (לגלול, לשלוח הודעה, דייט לא נכון, אוכל, אלכוהול)\n[כאן אני כותב]",
      "2. מה אני באמת מנסה להרגיע דרך זה? (פחד, שקט, אישור, חוסר ערך)\n[כאן אני כותב]",
      "3. מה חלופה אחת נקייה שמכבדת אותי היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני יכול/ה להרגיע את הלב בלי לפגוע בעצמי."
    ],
      [
      "סגירה",
      "אני יכול/ה להרגיע את הלב בלי לפגוע בעצמי."
    ]
    ),
    action: localizedGenderNode(
      "לפני פעולה אימפולסיבית: “עצירת 30 שניות” — נשימה + “אני בוחר/ת בי קודם.”",
      "לפני פעולה אימפולסיבית: “עצירת 30 שניות” — נשימה + “אני בוחר/ת בי קודם.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מה הבדידות מבקשת ממני",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לבקשה שמתחת לבדידות."
    ],
      [
      "היום אני מקשיב/ה לבקשה שמתחת לבדידות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בדידות היא צורך שמבקש להישמע.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בדידות היא צורך שמבקש להישמע.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. אם הבדידות הייתה יכולה לדבר — מה היא הייתה מבקשת?\n[כאן אני כותב]",
      "2. איזה צורך הוא הכי חזק אצלי עכשיו? (חום/שייכות/הכרה/מגע/מבט)\n[כאן אני כותב]",
      "3. איך אני נותן/ת לעצמי 10% מהצורך הזה היום בלי לחכות לאדם אחר?\n[כאן אני כותב]"
    ],
      [
      "1. אם הבדידות הייתה יכולה לדבר — מה היא הייתה מבקשת?\n[כאן אני כותב]",
      "2. איזה צורך הוא הכי חזק אצלי עכשיו? (חום/שייכות/הכרה/מגע/מבט)\n[כאן אני כותב]",
      "3. איך אני נותן/ת לעצמי 10% מהצורך הזה היום בלי לחכות לאדם אחר?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני מתחיל/ה לתת לעצמי משהו, גם אם מעט."
    ],
      [
      "סגירה",
      "אני מתחיל/ה לתת לעצמי משהו, גם אם מעט."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה פעולה אחת קטנה של חום עצמי (מקלחת/שמיכה/מוזיקה/הליכה/אוכל מסודר).",
      "אני עושה פעולה אחת קטנה של חום עצמי (מקלחת/שמיכה/מוזיקה/הליכה/אוכל מסודר)."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הבושה (“מה לא בסדר איתי?”)",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בבושה בלי לתת לה לקבוע מי אני."
    ],
      [
      "היום אני נוגע/ת בבושה בלי לתת לה לקבוע מי אני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בושה רוצה שאסתתר. היום אני נשאר/ת נוכח/ת.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בושה רוצה שאסתתר. היום אני נשאר/ת נוכח/ת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה המשפט הכי מבייש שעולה לי?\n[כאן אני כותב]",
      "2. אם חבר שאני אוהב היה אומר את זה על עצמו — מה הייתי אומר לו?\n[כאן אני כותב]",
      "3. מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום במקום בושה?\n[כאן אני כותב]"
    ],
      [
      "1. מה המשפט הכי מבייש שעולה לי?\n[כאן אני כותב]",
      "2. אם חבר שאני אוהב היה אומר את זה על עצמו — מה הייתי אומר לו?\n[כאן אני כותב]",
      "3. מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום במקום בושה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בושה לא אומרת אמת. היא אומרת שכואב לי."
    ],
      [
      "סגירה",
      "בושה לא אומרת אמת. היא אומרת שכואב לי."
    ]
    ),
    action: localizedGenderNode(
      "יד על חזה/בטן (אם נעים) + משפט רך אחד בלבד. פעם אחת.",
      "יד על חזה/בטן (אם נעים) + משפט רך אחד בלבד. פעם אחת."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "געגוע לאינטימיות (לא רק לזוגיות)",
    opening: localizedGenderNode(
      [
      "היום אני מזהה שאני מתגעגע/ת לאינטימיות, לא בהכרח “למישהו”."
    ],
      [
      "היום אני מזהה שאני מתגעגע/ת לאינטימיות, לא בהכרח “למישהו”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אינטימיות היא קרבה. יש לה הרבה צורות.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אינטימיות היא קרבה. יש לה הרבה צורות.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. למה אני מתגעגע/ת באמת? (שיחה עמוקה/מגע/חיבוק/מישהו שמכיר אותי)\n[כאן אני כותב]",
      "2. איפה בחיים שלי יש טיפת אינטימיות שכבר קיימת? (חבר/ילדים/משפחה/עבודה/רוח)\n[כאן אני כותב]",
      "3. איך אני יוצר/ת היום רגע קטן של אינטימיות נקייה?\n[כאן אני כותב]"
    ],
      [
      "1. למה אני מתגעגע/ת באמת? (שיחה עמוקה/מגע/חיבוק/מישהו שמכיר אותי)\n[כאן אני כותב]",
      "2. איפה בחיים שלי יש טיפת אינטימיות שכבר קיימת? (חבר/ילדים/משפחה/עבודה/רוח)\n[כאן אני כותב]",
      "3. איך אני יוצר/ת היום רגע קטן של אינטימיות נקייה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא מחכה לאידיאל. אני מתחיל/ה לבנות קרבה בהדרגה."
    ],
      [
      "סגירה",
      "אני לא מחכה לאידיאל. אני מתחיל/ה לבנות קרבה בהדרגה."
    ]
    ),
    action: localizedGenderNode(
      "שיחה קצרה אחת עם אדם בטוח — בלי להצדיק, רק להיות.",
      "שיחה קצרה אחת עם אדם בטוח — בלי להצדיק, רק להיות."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "חשיפה נקייה (ACT עדין): להיות לבד דקה בלי לברוח",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת לשהות עם הבדידות רגע — בלי לברוח."
    ],
      [
      "היום אני מתרגל/ת לשהות עם הבדידות רגע — בלי לברוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני יכול/ה להיות עם זה דקה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני יכול/ה להיות עם זה דקה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מתי הכי קשה לי להיות לבד?\n[כאן אני כותב]",
      "2. תרגול דקה: אני יושב/ת עם התחושה דקה אחת, בלי מסך. מה קרה בגוף?\n[כאן אני כותב]",
      "3. מה למדתי על הגל? (האם הוא באמת לא עובר?)\n[כאן אני כותב]"
    ],
      [
      "1. מתי הכי קשה לי להיות לבד?\n[כאן אני כותב]",
      "2. תרגול דקה: אני יושב/ת עם התחושה דקה אחת, בלי מסך. מה קרה בגוף?\n[כאן אני כותב]",
      "3. מה למדתי על הגל? (האם הוא באמת לא עובר?)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני מתחזק/ת לא כי נעלם הרגש — אלא כי נשארתי."
    ],
      [
      "סגירה",
      "אני מתחזק/ת לא כי נעלם הרגש — אלא כי נשארתי."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד. עקביות > כוח.",
      "דקה אחת בלבד. עקביות > כוח."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבולות מול עצמי (לא לרוץ לקשר לא נכון)",
    opening: localizedGenderNode(
      [
      "היום אני מגן/ה על הלב שלי מפני “פתרונות מהירים”."
    ],
      [
      "היום אני מגן/ה על הלב שלי מפני “פתרונות מהירים”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “קשר לא נכון לא פותר בדידות — הוא מוסיף כאב.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “קשר לא נכון לא פותר בדידות — הוא מוסיף כאב.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה “כיוון מהיר” אני נוטה לבחור כשאני לבד?\n[כאן אני כותב]",
      "2. מה המחיר שאני משלם/ת כשאני בוחר/ת ככה?\n[כאן אני כותב]",
      "3. איזה גבול אחד קטן אני שם השבוע כדי להגן עליי?\n[כאן אני כותב]"
    ],
      [
      "1. איזה “כיוון מהיר” אני נוטה לבחור כשאני לבד?\n[כאן אני כותב]",
      "2. מה המחיר שאני משלם/ת כשאני בוחר/ת ככה?\n[כאן אני כותב]",
      "3. איזה גבול אחד קטן אני שם השבוע כדי להגן עליי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול הוא אהבה עצמית בפעולה."
    ],
      [
      "סגירה",
      "גבול הוא אהבה עצמית בפעולה."
    ]
    ),
    action: localizedGenderNode(
      "אני מסיר/ה טריגר אחד שמוביל לפעולה לא נקייה (אפליקציה/צ’אט/מקום).",
      "אני מסיר/ה טריגר אחד שמוביל לפעולה לא נקייה (אפליקציה/צ’אט/מקום)."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“כולם בזוג ואני לבד” (לשבור את המיתוס)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה לקרוא חיים של אחרים מתוך תמונה."
    ],
      [
      "היום אני מפסיק/ה לקרוא חיים של אחרים מתוך תמונה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא יודע/ת את כל הסיפור שלהם.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא יודע/ת את כל הסיפור שלהם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה משפט השוואה עולה לי?\n[כאן אני כותב]",
      "2. מה אני באמת יודע/ת ומה אני רק מנחש/ת?\n[כאן אני כותב]",
      "3. איזו אמת אחת על הדרך שלי אני בוחר/ת לזכור היום?\n[כאן אני כותב]"
    ],
      [
      "1. איזה משפט השוואה עולה לי?\n[כאן אני כותב]",
      "2. מה אני באמת יודע/ת ומה אני רק מנחש/ת?\n[כאן אני כותב]",
      "3. איזו אמת אחת על הדרך שלי אני בוחר/ת לזכור היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הקצב שלי לא אומר שאני פחות. הוא אומר שאני במסלול שלי."
    ],
      [
      "סגירה",
      "הקצב שלי לא אומר שאני פחות. הוא אומר שאני במסלול שלי."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — אני מפסיק/ה השוואה: סוגר/ת מסך / נשימה / חוזר/ת לעצמי.",
      "פעם אחת היום — אני מפסיק/ה השוואה: סוגר/ת מסך / נשימה / חוזר/ת לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לבנות שגרה שמחזיקה אותי",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי עוגן — כדי שהלב לא יישאר בלי קרקע."
    ],
      [
      "היום אני נותן/ת לעצמי עוגן — כדי שהלב לא יישאר בלי קרקע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני בונה יציבות בצעדים קטנים.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני בונה יציבות בצעדים קטנים.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. באיזה שעות ביום הבדידות הכי תוקפת אותי?\n[כאן אני כותב]",
      "2. מה עוגן אחד פשוט שיכול להיכנס לשם? (הליכה/ארוחה/מקלחת/מוזיקה/סדר)\n[כאן אני כותב]",
      "3. מה אני מתרוצה/ת לעשות 10 דקות בלבד היום?\n[כאן אני כותב]"
    ],
      [
      "1. באיזה שעות ביום הבדידות הכי תוקפת אותי?\n[כאן אני כותב]",
      "2. מה עוגן אחד פשוט שיכול להיכנס לשם? (הליכה/ארוחה/מקלחת/מוזיקה/סדר)\n[כאן אני כותב]",
      "3. מה אני מתרוצה/ת לעשות 10 דקות בלבד היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "שגרה קטנה היא חיבוק קבוע."
    ],
      [
      "סגירה",
      "שגרה קטנה היא חיבוק קבוע."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה את ה-10 דקות — ולא מוסיף עוד.",
      "אני עושה את ה-10 דקות — ולא מוסיף עוד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "לתרגל “להיות נראה” בלי זוגיות",
    opening: localizedGenderNode(
      [
      "היום אני מחזיר/ה לעצמי נראות ושייכות — בדרך נקייה."
    ],
      [
      "היום אני מחזיר/ה לעצמי נראות ושייכות — בדרך נקייה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גם בלי זוגיות — מגיע לי להיות נראה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גם בלי זוגיות — מגיע לי להיות נראה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה בחיי אני מרגיש/ה לא נראה?\n[כאן אני כותב]",
      "2. מה דרך אחת בריאה להיות בקשר היום? (שיחה/קבוצה/משפחה/חבר/קהילה)\n[כאן אני כותב]",
      "3. מה מפחיד אותי בלבקש חיבור?\n[כאן אני כותב]"
    ],
      [
      "1. איפה בחיי אני מרגיש/ה לא נראה?\n[כאן אני כותב]",
      "2. מה דרך אחת בריאה להיות בקשר היום? (שיחה/קבוצה/משפחה/חבר/קהילה)\n[כאן אני כותב]",
      "3. מה מפחיד אותי בלבקש חיבור?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בקשת חיבור היא אומץ, לא חולשה."
    ],
      [
      "סגירה",
      "בקשת חיבור היא אומץ, לא חולשה."
    ]
    ),
    action: localizedGenderNode(
      "אני שולח/ת הודעה אחת נקייה לאדם בטוח: “בא לי לשמוע אותך.”",
      "אני שולח/ת הודעה אחת נקייה לאדם בטוח: “בא לי לשמוע אותך.”"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "הלילה והלופים (בדידות בשעות שקטות)",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת למוח “סיום פרק” כדי לנוח."
    ],
      [
      "היום אני נותן/ת למוח “סיום פרק” כדי לנוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הלילה אני לא רוצה/ת לפתור.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הלילה אני לא רוצה/ת לפתור.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה הלופ הלילי שלי סביב בדידות?\n[כאן אני כותב]",
      "2. מה הלופ מנסה להשיג בשבילי? (שליטה/תקווה/אישור)\n[כאן אני כותב]",
      "3. איזה משפט סגירה ללילה אני בוחר/ת — ואיזה טקס 3 דקות יעזור לי לפני שינה?\n[כאן אני כותב]"
    ],
      [
      "1. מה הלופ הלילי שלי סביב בדידות?\n[כאן אני כותב]",
      "2. מה הלופ מנסה להשיג בשבילי? (שליטה/תקווה/אישור)\n[כאן אני כותב]",
      "3. איזה משפט סגירה ללילה אני בוחר/ת — ואיזה טקס 3 דקות יעזור לי לפני שינה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מוח עייף מספר סיפורים חזקים. הלילה אני בוחר/ת מנוחה."
    ],
      [
      "סגירה",
      "מוח עייף מספר סיפורים חזקים. הלילה אני בוחר/ת מנוחה."
    ]
    ),
    action: localizedGenderNode(
      "לפני שינה: משפט הסגירה + נשימה אחת. זה הכול.",
      "לפני שינה: משפט הסגירה + נשימה אחת. זה הכול."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "להפוך בדידות לכיוון (מה אני בונה עכשיו)",
    opening: localizedGenderNode(
      [
      "היום הבדידות הופכת למצפן: מה חשוב לי באמת."
    ],
      [
      "היום הבדידות הופכת למצפן: מה חשוב לי באמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “מה שחסר לי — מלמד אותי מה אני רוצה לבנות.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “מה שחסר לי — מלמד אותי מה אני רוצה לבנות.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני רוצה בחיים שלי יותר מכל? (קשר/בית/שייכות/קרבה/שותפות)\n[כאן אני כותב]",
      "2. איזה ערך אחד יוביל אותי מעכשיו? (כבוד/אמת/שקט/יציבות/עדינות)\n[כאן אני כותב]",
      "3. איזה הרגל קטן מקרב אותי לערך הזה השבוע — ומה אני מבטיח/ה לעצמי ביום קשה? (משפט אחד)\n[כאן אני כותב]"
    ],
      [
      "1. מה אני רוצה בחיים שלי יותר מכל? (קשר/בית/שייכות/קרבה/שותפות)\n[כאן אני כותב]",
      "2. איזה ערך אחד יוביל אותי מעכשיו? (כבוד/אמת/שקט/יציבות/עדינות)\n[כאן אני כותב]",
      "3. איזה הרגל קטן מקרב אותי לערך הזה השבוע — ומה אני מבטיח/ה לעצמי ביום קשה? (משפט אחד)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת להישאר במקום של כאב. אני יכול/ה לבנות חיים."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת להישאר במקום של כאב. אני יכול/ה לבנות חיים."
    ]
    ),
    action: localizedGenderNode(
      "אני מתכנן/ת דבר אחד קטן לשבוע הקרוב שמחזיר לי עתיד (פגישה/קבוצה/פרויקט).",
      "אני מתכנן/ת דבר אחד קטן לשבוע הקרוב שמחזיר לי עתיד (פגישה/קבוצה/פרויקט)."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "טקס שחרור וסגירה (להישאר עם עצמי)",
    opening: localizedGenderNode(
      [
      "היום אני סוגר/ת פרק בלי למחוק אותו. אני מחזיר/ה את עצמי לעצמי."
    ],
      [
      "היום אני סוגר/ת פרק בלי למחוק אותו. אני מחזיר/ה את עצמי לעצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני משחרר/ת בלי להיעלם.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני משחרר/ת בלי להיעלם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. שלושה דברים שאני מפסיק/ה לעשות כשאני מרגיש/ה בדידות (כי הם פוגעים בי):\n[כאן אני כותב]",
      "2. שלושה דברים שאני מתחיל/ה לעשות כדי לבנות חום ושייכות:\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים (קצר, ברור, בכיס):\n[כאן אני כותב]"
    ],
      [
      "1. שלושה דברים שאני מפסיק/ה לעשות כשאני מרגיש/ה בדידות (כי הם פוגעים בי):\n[כאן אני כותב]",
      "2. שלושה דברים שאני מתחיל/ה לעשות כדי לבנות חום ושייכות:\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים (קצר, ברור, בכיס):\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא מוחק/ת בדידות —",
      "אני מפסיק/ה לתת לה להגדיר אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא מוחק/ת בדידות —",
      "אני מפסיק/ה לתת לה להגדיר אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת “פרק חדש”: הליכה במקום חדש / סידור יומן שבועי / שיחה אחת אמיצה.",
      "פעולה אחת שמסמלת “פרק חדש”: הליכה במקום חדש / סידור יומן שבועי / שיחה אחת אמיצה."
    ),
  },
].map(buildNormalizedDay);

export const romanticLonelinessBlueprintHe = buildNormalizedPilotBlueprint({
  id: "romantic_loneliness_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "romantic_loneliness",
  category: "general",
  journeyName: {
    he: "בדידות רומנטית",
    en: "Romantic Loneliness",
    es: "Soledad Romántica",
  },
  days,
});

export default romanticLonelinessBlueprintHe;
